import { push } from 'redux-first-history';
import { createCommand } from '../utils';
import { loggedOut, moduleName } from './state';

export const LogoutCommand = createCommand(`${moduleName}/LOG_OUT`, async (_, { dispatch, extra }) => {
    await extra.externalAuthentication.logout();
    await dispatch(loggedOut());
    await dispatch(push('/'));
});
